import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Space, Spin } from "antd";
import { MenuProps } from "antd/lib/menu";
import { ExportCSV } from "./export-csv";
import { RenderedQuery } from "./rendered-sql";
import { JobMeta } from "./job-meta";
import { JSONQuery } from "./json-query";
import { DownloadCSV } from "./download-csv";
import { FormInstance } from "antd/lib/form";
import { css } from "@emotion/react";
import { CreateExplorationButton } from "./create-exploration";

const DEFAULT_DROPDOWN_CHILDREN: React.ReactElement = (
    <Space
        className="py-1 px-3 rounded-[4px] bg-white  cursor-pointer flex items-center"
        onClick={(e) => e.stopPropagation()}
    >
        <DownOutlined /> More Actions
    </Space>
);

export type ChartActionProps = {
    tabKey: string;
    tabName: string;
    form?: FormInstance;
    dropdownChildren?: React.ReactElement;
    builtinMenuItemKeys?: (
        | "export-csv"
        | "download-csv"
        | "job-meta"
        | "rendered-query"
        | "json-query"
        | "create_exploration"
    )[];
    extendedMenuItems?: MenuProps["items"];
    trigger?: ("click" | "hover")[];
    handleOpenChange?: (open: boolean) => void;
    loading?: boolean;
};
export const ChartAction: React.FC<ChartActionProps> = ({
    tabKey,
    tabName,
    form,
    dropdownChildren,
    builtinMenuItemKeys,
    extendedMenuItems,
    trigger = ["click", "hover"],
    handleOpenChange,
    loading = false,
}) => {
    const items: MenuProps["items"] = [
        {
            label: <ExportCSV tabKey={tabKey} tabName={tabName} />,
            key: "export-csv",
        },
        tabKey === "intelligence-search"
            ? {
                  label: <DownloadCSV tabKey={tabKey} tabName={tabName} />,
                  key: "download-csv",
              }
            : null,
        {
            label: <JobMeta tabKey={tabKey} tabName={tabName} />,
            key: "job-meta",
        },
        {
            label: <RenderedQuery tabKey={tabKey} tabName={tabName} />,
            key: "rendered-query",
        },

        {
            label: <JSONQuery tabKey={tabKey} tabName={tabName} />,
            key: "json-query",
        },
        {
            label: <CreateExplorationButton tabKey={tabKey} tabName={tabName} />,
            key: "create_exploration",
        },
    ]
        .filter((f) => !!f)
        .filter(({ key }) => {
            return builtinMenuItemKeys === undefined || builtinMenuItemKeys.includes(key);
        });

    items.push(...(extendedMenuItems || []));

    return (
        <Dropdown
            menu={{ items }}
            trigger={trigger}
            onOpenChange={handleOpenChange}
            popupRender={(originNode) => {
                return (
                    <Spin spinning={loading}>
                        <div
                            css={css`
                                li {
                                    padding: 0 !important;
                                }
                            `}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {originNode}
                        </div>
                    </Spin>
                );
            }}
        >
            {dropdownChildren || DEFAULT_DROPDOWN_CHILDREN}
        </Dropdown>
    );
};

export const ChartActionLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return <div className="absolute -top-2 right-0">{children}</div>;
};
